import { useMemo } from "react";
import { getOwnerDocument as u } from "../utils/owner.js";
function n(...e) {
  return useMemo(() => u(...e), [...e]);
}
export {
  n as useOwnerDocument
};
